import { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import equal from 'deep-equal';
import { getMyProfile as getMyProfileAction } from '../actions/profile';
import { omit } from '../utils/object';
import { getQueryObject } from '../utils/url';
import {
  attachSearchBar as attachSearchBarAction,
  updateCurrentUrl as updateCurrentUrlAction
} from '../actions/masterbrand';

const mapDispatchToProps = {
  attachSearchBar: attachSearchBarAction,
  getMyProfile: getMyProfileAction,
  updateCurrentUrl: updateCurrentUrlAction
};

const mapStateToProps = ({ session: { isAuthenticated, user } }) => ({
  isAuthenticated,
  user
});

class MasterbrandHeader extends Component {
  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
  }
  componentWillMount() {
    // Profile is required for page header render if logged in
    const {
      isAuthenticated,
      user,
      getMyProfile,
    } = this.props;

    if (isAuthenticated && !user) {
      getMyProfile();
    }
  }

  componentDidMount() {
    this.props.attachSearchBar(this.onSubmit);
  }

  shouldComponentUpdate({ location }) {
    return !equal(omit(['key'], location), omit(['key'], this.props.location));
  }

  componentDidUpdate() {
    this.props.updateCurrentUrl();
  }

  onSubmit(newQuery) {
    const { query } = getQueryObject(window.location.search);
    if (query !== newQuery) {
      this.props.history.push(`/?query=${encodeURIComponent(newQuery)}`);
    }
  }

  render() {
    return null;
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(MasterbrandHeader));



// WEBPACK FOOTER //
// ./src/universal/ui/components/MasterbrandHeader.js